import mixpanel from 'mixpanel-browser';
import { AnalyticsEventBus, event } from '../analytics';
import { prop } from '.';

export class UserAuthenticationMixpanelHandlers {
  static handleAll() {
    this.handleViewEvents();
    this.handleSubmitEvents();
    this.handleActionEvents();
  }

  static handleViewEvents() {
    AnalyticsEventBus.$on(event.view.login, (data) => {
      mixpanel.track(event.view.login, { Language: prop.languages[data.language] });
    });
  }

  static handleSubmitEvents() {
    AnalyticsEventBus.$on(event.submit.login, (data) => {
      mixpanel.track(event.submit.login, {
        Email: data.loginFormProperties.username,
        Password: data.loginFormProperties.password.replace(/./g, "*"),
        "Login by": prop.loginSources[data.loginFormProperties.userType],
        "Keep Login": data.loginFormProperties.keepLogin,
        Language: prop.languages[data.language],
        Succeeded: data.succeeded
      });
    });
  }

  static handleActionEvents() {
    AnalyticsEventBus.$on(event.action.identify, (data) => {
      mixpanel.people.set({
        "User ID": Number(data.id).toString(),
        $avatar: data.picture,
        Username: data.given_name,
        $first_name: data.firstName,
        $last_name: data.lastName,
        $phone: data.phone_number,
        $email: data.userEmail,
        $created: data.registerDateTime,
        Birthdate: data.birthdate
      });
      mixpanel.identify(data.id);
    });

    AnalyticsEventBus.$on(event.action.unidentify, (data) => {
      mixpanel.reset();
    });
  }
}
